import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { CustomizerSettingsService } from "../../../helpers/customizer-settings.service";
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import {
    MatDialog,
    MAT_DIALOG_DATA,
    MatDialogRef,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
} from '@angular/material/dialog';

import { UserLight } from '../../../apis/models/userLight';
import { UserHelper } from '../../../helpers/user.helper';
import { UserService } from '../../../apis/services/user.service';
import { UserTypeEnum } from '../../../apis/enums/userType.enum';
import { CommonHelpers } from '../../../helpers/common.helper';

export interface DialogData {
    username: string
}

export enum SortByEnum {
    USERNAME = 'Username',
    ACCOUNT_TYPE = 'Tipologia account',
    EMAIL = 'Email'
}

@Component({
    selector: 'app-users-list',
    templateUrl: './users-list.component.html',
    styleUrl: './users-list.component.scss'
})
export class UsersListComponent implements OnInit {
    
    displayedColumns: string[] = ['username', 'nominativo', 'email', 'tipo', 'actions'];
    dataSource = new MatTableDataSource<UserLight>([]);
    sortby: string = SortByEnum.USERNAME
    isToggled = false;

    protected readonly sortEnumList = Object.values(SortByEnum);

    @ViewChild(MatPaginator)
    paginator!: MatPaginator;
    @ViewChild(MatSort)
    sort!: MatSort;

    constructor(
        public themeService: CustomizerSettingsService,
        private userService: UserService,
        private userHelper: UserHelper,
        private commonHelpers: CommonHelpers,
        public dialog: MatDialog
    ) {
        this.themeService.isToggled$.subscribe(isToggled => {
            this.isToggled = isToggled;
        });
    }

    ngAfterViewInit() {
        this.dataSource.paginator = this.paginator;
    }

    applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.dataSource.filter = filterValue.trim().toLowerCase();
    }

    // RTL Mode
    toggleRTLEnabledTheme() {
        this.themeService.toggleRTLEnabledTheme();
    }

    ngOnInit(): void {
        this.userHelper.userSubject.subscribe(dataSource => {
            this.dataSource.data = dataSource;
        });
        this.loadUsers();
    }

    loadUsers() {
        this.userService.getUsers().subscribe({
            next: (dataSource) => {
                this.dataSource.data = dataSource;
            },
            error: (error) => {
                this.commonHelpers.openSnackBar("Si è verificato un errore nel caricamento degli utenti", "x", 5);
            }

        });

    }

    openDeleteDialog(IDAccount: number, username: string): void {
        const dialogRef = this.dialog.open(DialogOverviewExampleDialog, {
            data: {delete: false, username: username},
        });
        dialogRef.afterClosed().subscribe(result => {
            if(result){
                this.deleteUser(IDAccount)
            }
        });
    }

    deleteUser(IDAccount: number): any {
        this.userService.deleteUser(IDAccount).subscribe({
                next: () => {
                    this.dataSource.data = this.dataSource.data.filter(user => user.IDAccount !== IDAccount);
                },
                error: (error) => {
                    this.commonHelpers.openSnackBar("Si è verificato un errore durante l'eliminazioe dell'utente", "x", 5);
                    console.error('Error occurred while deleting user:', error);
                }
            }
        );
    }

    sortBy(type: SortByEnum){
        this.sortby = type
        switch (type) {
            case SortByEnum.USERNAME:
                this.dataSource.data.sort((a, b) => a.username!.localeCompare(b.username!));
                this.dataSource._updateChangeSubscription();
                break;
            case SortByEnum.ACCOUNT_TYPE:
                this.dataSource.data.sort((a, b) => a.accountType!.localeCompare(b.accountType!));
                this.dataSource._updateChangeSubscription();
                break;
            case SortByEnum.EMAIL:
                this.dataSource.data.sort((a, b) => a.email!.localeCompare(b.email!));
                this.dataSource._updateChangeSubscription();
                break;
        }
    }

    getEnumDescription(type: string): string {
        return UserTypeEnum[type as keyof typeof UserTypeEnum];
    }
}
@Component({
    selector: 'dialog-overview-example-dialog',
    templateUrl: 'delete-user-dialog.component.html',
    imports: [
        MatFormFieldModule,
        MatButtonModule,
        MatDialogTitle,
        MatDialogContent,
        MatDialogActions,
        MatDialogClose,
    ],
    standalone: true
})
export class DialogOverviewExampleDialog {

    constructor(
        public dialogRef: MatDialogRef<DialogOverviewExampleDialog>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData,
    ) {}

    onNoClick(): void {
        this.dialogRef.close();
    }

}